<template>
  <span></span>
</template>

<script>
  export default {
    name: "removeInvoiceAlertIcon"
  }
</script>

<style scoped>
  span {
    float: left;
    margin: 2px 5px 5px 7px;
    width: 16px;
    height: 16px;
    display: block;
    text-indent: -99999px;
    overflow: hidden;
    background: url(../../../../assets/ui-icons_72a7cf_256x240.png) no-repeat 0 -144px;
    color: #362b36;
  }
</style>
